import React from 'react'
import Home from './Home/Nav'
import Autotone from './Autotone/Nav'
import Preset from './Preset/Nav'
import SmartObject from './SmartObject/Nav'
import TextLayer from './TextLayer/Nav'
import ImageCutout from './ImageCutout/Nav'
import PsActions from './PsActions/Nav'
import BannerReflow from './BannerReflow/Nav'

export default function Nav ({ page }) {
    return (
        // this extra wrapper div is to prevent the main nav from animating because of the
        // relative positioning of elements
        <div className="adobe-easybake-nav-wrapper">
            {page === 'home' && <Home />}
            {page === 'autotone' && <Autotone />}
            {page === 'preset' && <Preset />}
            {page === 'smartobject' && <SmartObject />}
            {page === 'textlayer' && <TextLayer />}
            {page === 'imagecutout' && <ImageCutout />}
            {page === 'psactions' && <PsActions />}
            {page === 'bannerreflow' && <BannerReflow />}
        </div>
    )
}
